(function () {
  'use strict';

  let angular = window.angular;

  SupportAdminUnlinkController.$inject = ['Var', 'AppUtils', 'LocalStorageService'];

  angular.module('app').component('supportAdminUnlinkModal', {
    template:'<div ng-style="{opacity: ctrl.loading? 0: 1}"><div class="modal-header"><span translate>buttons.unlink</span> <span translate>entities.user.modelName</span></div><div class="modal-body text-center"><div translate-values="{user: ctrl.SupportAdmin.name + \' \' + ctrl.SupportAdmin.surname}" translate>entities.user.messages.unlink</div></div><div ng-if="ctrl.ublinkUserError" class="alert alert-warning text-center marginB0 marginT10">{{ctrl.ublinkUserError}}</div><div class="modal-footer"><button class="btn btn-default pull-left" ng-click="ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-danger" ng-click="ctrl.unlinkUser()" translate>buttons.unlink</button></div></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small\'"></spinner>',
    controller: SupportAdminUnlinkController,
    controllerAs: 'ctrl',
    bindings: {
      modalInstance: '<',
      resolve: '<',
    },
  });

  function SupportAdminUnlinkController(Var, utils, LocalStorageService) {
    let vm = this;

    vm.$onInit = function onInit() {
      vm.SupportAdmin = vm.resolve.user;
      vm.varId = vm.resolve.varId;
      vm.unlinkUser = unlinkUser;
    };

    function unlinkUser() {
      if (!vm.SupportAdmin) {
        return;
      }

      vm.loading = true;
      Var.prototype$__unlink__supportAdmins({ id: vm.varId, fk: vm.SupportAdmin.id }, {})
        .$promise.then(function () {
          vm.loading = false;
          LocalStorageService.clear();
          vm.modalInstance.close();
        })
        .catch(function (err) {
          vm.loading = false;
          let error = utils.getHTTPError(err);
          vm.UnlinkUserError = error.code || error.message;
        });
    }
  }
})();
